var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSnowflake = function SvgSnowflake(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 10h-7 2.414H12h7Zm-8 2.586 4.707 4.707a1 1 0 0 1-1.414 1.414L11 15.414V19a1 1 0 0 1-2 0v-3.586l-3.293 3.293a1 1 0 1 1-1.414-1.414L9 12.586V11H7.414l-4.707 4.707a1 1 0 1 1-1.414-1.414L4.586 11H1a1 1 0 0 1 0-2h3.586L1.293 5.707a1 1 0 1 1 1.414-1.414L7.414 9H9V7.414L4.293 2.707a1 1 0 0 1 1.414-1.414L9 4.586V1a1 1 0 1 1 2 0v3.586l3.293-3.293a1 1 0 0 1 1.414 1.414L11 7.414V9h1.586l4.707-4.707a1 1 0 0 1 1.414 1.414L15.414 9H19a1 1 0 0 1 0 2h-3.586l3.293 3.293a1 1 0 0 1-1.414 1.414L12.586 11H11v1.586Zm-2 2.828 1-1V19v-6 1.414l-1 1Z",
    fill: "#fff",
    fillRule: "evenodd"
  })));
};
export default SvgSnowflake;